import { useTheme } from '@mui/styles';

const cardHeight = 192;
const cardWidth = 340;

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    chartCard: {
      height: '100%',
      minHeight: `${cardHeight}px`,
      padding: 0,
      width: `${cardWidth}px`,
    },
    chartHeader: {
      padding: theme.spacing(1, 1, 0),
    },
    chartCardTitle: {
      fontSize: '1.3rem',
    },
    chartCardContent: {
      padding: 0,
      '&:last-child': {
        paddingBottom: 0,
      },
      '&:not(:last-child)': {
        paddingBottom: 0,
      },
    },
    donutChartContainer: {
      height: '160px',
      padding: theme.spacing(0, 1, 1),
      position: 'relative',
      width: `${cardWidth}px`,
    },
    donutChartTotal: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      position: 'absolute',
      right: '66px',
      top: '43%',
      width: '112px',

      '& *': {
        fontSize: '0.9rem',
      },
    },

    likertChartContainer: {
      height: '160px',
      padding: theme.spacing(0, 1, 1),
      position: 'relative',
      width: `${cardWidth}px`,

      '& text': {
        transform: 'translate(0, 30px)',
      },
    },
    likertLegend: {
      bottom: theme.spacing(),
      position: 'absolute',
      maxHeight: '50px',
      maxWidth: `${cardWidth - 16}px`,
    },

    barChartContainer: {
      height: '160px',
      padding: theme.spacing(0, 1, 1),
      position: 'relative',
      width: `${cardWidth}px`,

      '& g ~ line': {
        '@media print': {
          display: 'none',
        },
      },
    },
    colorBox: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '11px',
    },
  };
};
